module.exports = __webpack_public_path__ + "static/img/login-banner.5f1540b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-banner.png
// module id = XeWC
// module chunks = 1